export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const BASE_URL = 'https://devsu.com';
export const GET_STARTED_HOME_UID = 'get-started';
